import React from 'react';
import { createCtx } from '@panwds/react-ui';

const [useWizardContext, InnerWizardProvider] = createCtx();
function WizardProvider({ children, context, }) {
    return React.createElement(InnerWizardProvider, { value: context }, children);
}

export { WizardProvider, useWizardContext };
//# sourceMappingURL=WizardContext.esm.js.map
